/* Hike Adventure: countdowns require an explicit campaign end with timezone.
   No configured deadline means no urgency display. Expired campaigns stay hidden.
   Dagdeal (Lou, 25 okt): in de header staan een datum en de collecties die op die
   dag korting hebben. De klok telt dan af naar 00:00 Amsterdam aan het eind van
   die dag, alleen op die dag en alleen bij producten uit die collecties. Is de
   datum niet ververst, dan geen klok: die deal eindigt niet echt.
   Dag "auto" (Lou, 25 okt): elke dag tot 00:00, omdat Lou elke nacht om 00:00
   zelf de prijzen aanpast. Collecties "*": alle producten met korting. */
(function () {
  var TICK = null;
  var pad = function (n) { return n < 10 ? '0' + n : String(n); };

  function msLeft(deadline) {
    if (!deadline || !/(Z|[+-]\d{2}:\d{2})$/.test(deadline)) return 0;
    var end = Date.parse(deadline);
    return Number.isFinite(end) ? Math.max(0, end - Date.now()) : 0;
  }

  var AMS = null;
  try {
    AMS = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  } catch (e) {}

  function amsKey(t) {
    var p = {};
    AMS.formatToParts(new Date(t)).forEach(function (x) { p[x.type] = x.value; });
    return p.year + '-' + p.month + '-' + p.day + ' ' + p.hour + ':' + p.minute;
  }

  /* 00:00 in Amsterdam aan het begin van dag "YYYY-MM-DD", in ms. Winter is UTC+1,
     zomer UTC+2; welke van de twee geldt, zegt de tijdzonedatabase van de browser. */
  function midnight(day) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day || '');
    if (!m || !AMS) return 0;
    for (var off = 1; off <= 2; off++) {
      var t = Date.UTC(+m[1], m[2] - 1, +m[3]) - off * 3600000;
      if (amsKey(t) === m[0] + ' 00:00') return t;
    }
    return 0;
  }

  function dayLeft(day) {
    if (day === 'auto') day = AMS ? amsKey(Date.now()).slice(0, 10) : '';
    var start = midnight(day);
    if (!start) return 0;
    var next = new Date(Date.UTC(+day.slice(0, 4), day.slice(5, 7) - 1, +day.slice(8, 10) + 1)).toISOString().slice(0, 10);
    var end = midnight(next), now = Date.now();
    return end && now >= start && now < end ? end - now : 0;
  }

  function inDeal(mine, cols) {
    if (cols === '*') return true;
    if (!mine || !cols) return false;
    var own = ' ' + mine + ' ', list = cols.split(' ');
    for (var i = 0; i < list.length; i++) if (list[i] && own.indexOf(' ' + list[i] + ' ') > -1) return true;
    return false;
  }

  /* Resterende tijd voor één klok: een eigen einddatum, of de dagdeal uit de header. */
  function until(el) {
    var end = el.getAttribute('data-ha-cd-end');
    if (end) return msLeft(end);
    var deal = document.querySelector('[data-ha-cd-day]');
    if (!deal) return 0;
    if (el !== deal && !inDeal(el.getAttribute('data-ha-cd-in'), deal.getAttribute('data-ha-cd-cols'))) return 0;
    return dayLeft(deal.getAttribute('data-ha-cd-day'));
  }

  function stamp(ms) {
    if (!(ms > 0)) ms = 0;
    var s = Math.floor(ms / 1000);
    return pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s % 3600 / 60)) + ':' + pad(s % 60);
  }

  function paint() {
    var els = document.querySelectorAll('[data-ha-cdclock]');
    var active = 0;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ms = until(el);
      if (!ms) { el.hidden = true; continue; }
      active++;
      var t = stamp(ms);
      var tpl = el.getAttribute('data-tpl') || '~T~';
      var out = el.querySelector('[data-ha-cdclock-out]');
      if (!out) continue;
      /* De tijd staat in een eigen element zodat alleen dat stukje per
         seconde verandert en de zin eromheen met rust wordt gelaten. */
      var parts = tpl.split('~T~');
      var pre = el.querySelector('[data-ha-cdclock-pre]');
      var post = el.querySelector('[data-ha-cdclock-post]');
      if (pre && pre.textContent !== parts[0]) pre.textContent = parts[0];
      if (post && post.textContent !== (parts[1] || '')) post.textContent = parts[1] || '';
      if (out.textContent !== t) out.textContent = t;
      if (el.hasAttribute('hidden')) el.removeAttribute('hidden');
    }
    if (!active && TICK) { clearInterval(TICK); TICK = null; }
  }

  function mount() {
    var els = document.querySelectorAll('[data-ha-cdclock]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (!until(el)) { el.hidden = true; continue; }
      if (el.getAttribute('data-ha-cdclock') === 'on') continue;
      el.setAttribute('data-ha-cdclock', 'on');
      if (!el.querySelector('[data-ha-cdclock-out]')) {
        el.innerHTML = '<span data-ha-cdclock-pre></span>'
          + '<b data-ha-cdclock-out></b>'
          + '<span data-ha-cdclock-post></span>';
      }
    }
    paint();
    if (!TICK && Array.prototype.some.call(els, function(el) { return until(el) > 0; })) TICK = setInterval(paint, 1000);
  }

  window.HACd = { mount: mount, left: msLeft, until: until, dayLeft: dayLeft, stamp: stamp };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  document.addEventListener('shopify:section:load', mount);
})();
